import { PISANO_THEME } from '@vision/theme';

export const DEFAULT_TAG_BACKGROUND_COLOR = PISANO_THEME.colors.blue[5];
export const DEFAULT_TAG_FONT_COLOR = PISANO_THEME.white;
export const MAX_TAG_NAME_CHAR_COUNT = 100;

export const APPLICATION_PLATFORM_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'ios', label: 'iOS' },
  { value: 'android', label: 'Android' },
  { value: 'macos', label: 'MacOS' },
  { value: 'windows', label: 'Windows' },
];
